import { render } from "./RepoList.vue?vue&type=template&id=413d6167&scoped=true&ts=true"
import script from "./RepoList.vue?vue&type=script&lang=ts"
export * from "./RepoList.vue?vue&type=script&lang=ts"

import "./RepoList.vue?vue&type=style&index=0&id=413d6167&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413d6167"]])

export default __exports__